import Service from '@/services/abstract/service'

export default class Storage extends Service {

  constructor () {
    super()

    this._images  = this._storage.ref('Flyvendas/LayoutImage')
    this._pdf     = this._storage.ref('Flyvendas/PDF')
    this._videos  = this._storage.ref('Flyvendas/Videos')
  }

  uploadLayoutImage(file){
    return new Promise((resolve, reject) => {
      let fileName = `file-${new Date().getTime()}`

      let fileRef = this._images.child(fileName)
      let task = fileRef.put(file)

      task.on('state_changed', snapshot => {
        let percent = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
      }, error => {
        console.error(error)
        return reject(error)
      }, () => {
        task.snapshot.ref.getDownloadURL().then(url => {
          return resolve({
            fileName: fileName,
            url: url
          })
        })
      })
    })
  }

  uploadLayoutImageBase64(baseString) {
    return new Promise((resolve, reject) => {
      //let extension  = originalFile.name.split('.').pop()
      const fileName = `file-${new Date().getTime()}`

      let fileRef = this._images.child(fileName)
      let task = fileRef.putString(baseString, 'data_url')

      task.on(
        'state_changed',
        snapshot => {
          let percent = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        },
        error => {
          return reject(error)
        },
        () => {
          task.snapshot.ref.getDownloadURL().then(url => {
            return resolve({
              fileName: fileName,
              url: url
            })
          })
        }
      )
    })
  }

  uploadVideo(file) {
    return new Promise((resolve, reject) => {
      let fileName = `video-${new Date().getTime()}`

      let fileRef = this._videos.child(fileName)
      let task = fileRef.put(file)

      task.on('state_changed', snapshot => {
        let percent = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
      }, error => {
        console.error(error)
        return reject(error)
      }, () => {
        task.snapshot.ref.getDownloadURL().then(url => {
          return resolve({
            fileName,
            url
          })
        })
      })
    })
  }

  uploadPdf(file) {
    return new Promise((resolve, reject) => {
      let fileName = `pdf-${new Date().getTime()}`
      let metadata = {
        contentType: 'application/pdf'
      }

      let fileRef = this._pdf.child(fileName)
      let task = fileRef.put(file, metadata)

      task.on('state_changed', snapshot => {
        let percent = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
      }, error => {
        console.error(error)
        return reject(error)
      }, () => {
        task.snapshot.ref.getDownloadURL().then(url => {
          return resolve({
            fileName,
            url
          })
        })
      })
    })
  }

  uploadImagePdf(file) {
    return new Promise((resolve, reject) => {
      let fileName = `pdf-${new Date().getTime()}`
      let metadata = {
        contentType: 'image'
      }

      let fileRef = this._pdf.child(fileName)
      let task = fileRef.put(file, metadata)

      task.on('state_changed', snapshot => {
        let percent = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
      }, error => {
        console.error(error)
        return reject(error)
      }, () => {
        task.snapshot.ref.getDownloadURL().then(url => {
          return resolve({
            fileName,
            url
          })
        })
      })
    })
  }

}
